import PropTypes from "prop-types";

import { List, Box } from "@mui/material";

import useLocales from "../../../hooks/useLocales";
import { ListSubheaderStyle } from "./style";
import NavList from "./NavList";
import useAuth from "src/hooks/useAuth";

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({
  navConfig,
  isCollapse,
  ...other
}) {
  const {
    user: { user },
  } = useAuth();

  const { translate } = useLocales();
  return (
    <Box key="menu">
      {navConfig.map((group, index) => (
        <List key={`${group.subheader}-${index}`} disablePadding sx={{ px: 2 }}>
          <ListSubheaderStyle
            key={group.subheader}
            sx={{
              ...(isCollapse && {
                opacity: 0,
              }),
            }}
          >
            {translate(group.subheader)}
          </ListSubheaderStyle>

          {group.items.map((list, index) => {
            if (list.apply.includes(user.partnerTypeStr)) {
              return (
                <NavList
                  key={index}
                  data={list}
                  depth={1}
                  hasChildren={!!list.children}
                  isCollapse={isCollapse}
                />
              );
            }
            return <div key={index} />;
          })}
        </List>
      ))}
    </Box>
  );
}
